// Os rótulos em português que o painel mostra no lugar do valor cru do banco,
// como em knowledge.js:5-8. Ficam num lugar só porque a mesma proposta aparece
// na revisão, na paleta e no grafo — e "pending" traduzido de três jeitos
// diferentes na mesma tela é como o painel antigo começou a divergir de si mesmo.
//
// A chave desconhecida cai no valor cru de propósito: assunto novo no servidor
// tem de aparecer no painel como veio, não como vazio.

export const ESPECIE_DE_PROPOSTA: Record<string, string> = {
  melhoria: 'melhoria',
  correcao: 'correção',
  decisao: 'decisão',
  runbook: 'runbook',
  padrao: 'padrão',
};

export const SITUACAO_DA_PROPOSTA: Record<string, string> = {
  pending: 'pendente',
  approved: 'aprovada',
  rejected: 'rejeitada',
  superseded: 'substituída',
};

export const ESPECIE_DE_DECISAO: Record<string, string> = {
  decision: 'decisão',
  runbook: 'runbook',
  padrao: 'padrão',
};

export const ESPECIE_DE_LACUNA: Record<string, string> = {
  sem_doc: 'sem doc',
  doc_velha: 'doc velha',
  sem_dono: 'sem dono',
  contradicao: 'contradição',
  pergunta_sem_resposta: 'pergunta sem resposta',
};

export const SITUACAO_DA_SESSAO: Record<string, string> = {
  open: 'aberta',
  closed: 'fechada',
  abandoned: 'abandonada',
};

export const ESPECIE_DE_EVENTO: Record<string, string> = {
  tentativa: 'tentativa',
  descoberta: 'descoberta',
  beco: 'beco sem saída',
  decisao_local: 'decisão local',
  comando: 'comando',
  erro: 'erro',
  arquivo: 'arquivo',
};

export const CARIMBO_DO_RESUMO: Record<string, string> = {
  nao_confirmada: 'não confirmada',
  confirmada: 'confirmada',
  contestada: 'contestada',
  curado: 'curado',
};

export const rotulo = (mapa: Record<string, string>, chave?: string | null): string =>
  mapa[String(chave || '')] || String(chave || '');

export const shaCurto = (s?: string | null): string => String(s || '').slice(0, 8);

/** `agent:cursor/...` é proposta de IA; o painel marca isso com a etiqueta IA. */
export const deAgente = (origem?: string | null): boolean => String(origem || '').startsWith('agent:');
